import { TheNightlySection } from '@news-mono/common'
import { metrics } from '@news-mono/component-library'
import { GetRouteAdTargeting, PageType } from '@news-mono/web-common'
import { layout } from '../../App.routing'
import { EditionV4DTO } from '@west-australian-newspapers/publication-types'

export function createSpecificEditionPage(
    getAdTargeting: GetRouteAdTargeting,
    section: TheNightlySection,
    edition: EditionV4DTO,
): PageType<TheNightlySection> {
    const title = edition.heading ?? edition.seoHead
    const description = edition.teaser

    return {
        kind: 'page',
        heading: edition.title,
        pageType: 'static',
        hideHeading: true,
        refreshOnInactive: false,
        pageMeta: {
            title: title,
            description: description,
            link: [{ rel: 'canonical', href: edition._self }],
            meta: [
                {
                    property: 'og:image',
                    content: edition.socialImage?.src ?? '',
                },
                {
                    property: 'og:image:width',
                    content: edition.socialImage?.width.toString() ?? '0',
                },
                {
                    property: 'og:image:height',
                    content: edition.socialImage?.height.toString() ?? '0',
                },
                {
                    name: 'twitter:image',
                    content: edition.socialImage?.src ?? '',
                },
                {
                    property: 'og:description',
                    content: edition.teaser ?? edition.socialTeaser,
                },
                {
                    property: 'twitter:description',
                    content: edition.teaser ?? edition.socialTeaser,
                },
            ],
        },
        socialMeta: {
            title: title,
            description: description,
        },
        adTargeting: getAdTargeting('home', section, 'default'),
        section: section,

        compositions: [
            layout.composition({
                type: 'thor',
                props: {
                    containerWidth: '100%',
                    horizontalGutters: false,
                    verticalGutters: false,
                },
                contentAreas: {
                    main: [
                        layout.nestedComposition({
                            type: 'box',
                            props: {
                                verticalSpacing: 'md',
                                containerWidth:
                                    metrics.thenightly.siteMetrics
                                        .mainContentWidth,
                            },
                            contentAreas: {
                                main: [
                                    layout.component({
                                        type: 'nightly-specific-edition-focus',
                                        props: {
                                            edition,
                                            lazyloadImages: true,
                                        },
                                    }),
                                ],
                            },
                        }),
                        layout.component({
                            type: 'ad-unit',
                            props: {
                                adType: 'inline',
                                noticePosition: 'below-center',
                                slot: {
                                    id: 'single-editions-page',
                                    size: 'billboardAbove1280leaderboardAbove768MrecBelow',
                                },
                            },
                        }),
                    ],
                },
            }),
        ],
    }
}
